import React, { useState } from 'react'
import { Box, CssBaseline } from '@material-ui/core'
import Menu from '../components/menu'
import Header from '../components/header'
import Footer from '../components/footer'
import { useStyles } from './styles/index.styles'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/ReactToastify.min.css'

import { ThemeProvider } from '@mui/material/styles'
import theme from '../theme'
import useLayoutStyles from '../hooks/useLayoutStyles'
import { createSocketConnection } from '../../services/socketService'

/**
 * `frame` — a página é uma BANCADA, não um documento: ocupa exatamente a
 * viewport, cuida do próprio scroll por dentro e dispensa o rodapé.
 *
 * Existe porque as duas coisas são incompatíveis por construção. Uma página
 * normal precisa crescer com o conteúdo; uma bancada precisa de altura
 * definida para que um painel interno consiga rolar sozinho. Tentar servir as
 * duas com a mesma folha é o que produzia a faixa de scroll morta no fim de
 * TODA tela — a Entrevista chegava a 1998px de documento numa viewport de 900.
 *
 * É opt-in de propósito: nenhuma página existente muda de comportamento.
 */
export interface OpcoesTemplate {
  frame?: boolean;
}

const Wrapper = (Component: React.ComponentType, opcoes?: OpcoesTemplate) => {
  const classes = useStyles()

  const [showMenu, setShowMenu] = useState(true)

  const { contentContainerMarginLeft, smallScreen } = useLayoutStyles()

  const openMenu = () => {
    setShowMenu(!showMenu)
  }

  /**
   * Abre a conexão com o servidor websocket
   */
  createSocketConnection();

  const quadro = Boolean(opcoes?.frame)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box className={quadro ? classes.containerFrame : classes.container}>
        <ToastContainer position="bottom-right" newestOnTop theme="colored" />
        {!smallScreen && <Menu showMenu={showMenu} openMenu={openMenu} />}
        <Header showMenu={showMenu} />
        <Box
          component="main"
          ml={contentContainerMarginLeft+"px"}
          className={quadro ? classes.contentFrame : classes.contentContainer}
        >
          <Component />
        </Box>
        {!quadro && <Footer showMenu={showMenu} />}
      </Box>
    </ThemeProvider>
  )
}

const hipladeTemplate = (InputComponent: React.ComponentType, opcoes?: OpcoesTemplate) => {
  return () => Wrapper(InputComponent, opcoes)
}

export default hipladeTemplate
